const { FormatMoney } = require("format-money-js");
const fm = new FormatMoney({
  decimals: 2,
  symbol: "Rs. ",
});

export default function formatCurrency(value) {
  return fm.from(Number(value));
}
